import React, {Component} from 'react';
import {LazyLoadImage} from "react-lazy-load-image-component";

export default class Timeline extends Component {

    constructor(props) {
        super(props);

    }

    renderBlock() {
        return this.props.info.map((elem, index) => {
            let classStep = "";
            let srcNumber = "";
            if (index === 0) {
                classStep = "steps-one";
                srcNumber = process.env.CDN_URL+"/images/adoptaunanimal/timeline/number_1.jpg";
                // srcNumber = getImageEncode("number_1");
            } else if (index === 1) {
                classStep = "steps-two";
                srcNumber = process.env.CDN_URL+"/images/adoptaunanimal/timeline/number_2.jpg";
                // srcNumber = getImageEncode("number_2");
            } else if (index === 2) {
                classStep = "steps-three";
                srcNumber = process.env.CDN_URL+"/images/adoptaunanimal/timeline/number_3.jpg";
                // srcNumber = getImageEncode("number_3");
            }
            return (
                <div key={index} className={classStep}>
                    <LazyLoadImage threshold={150} className="steps-img" src={srcNumber} alt="" />
                    <div className="steps-description">
                        <p>
                            {elem.description}
                        </p>
                        <LazyLoadImage threshold={150} className="steps-img-description" src={elem.srcImageDescription} alt="" />
                    </div>
                </div>
            );
        })
    }

    render() {
        return (
            <div>
                <div className="steps-timeline-bar"></div>
                <div className="steps-timeline">
                    {this.renderBlock()}
                </div>
            </div>
        );
    }
}